import { ca } from '@cian/analytics';

import { IFavoriteEntity } from '../../types/results';
import { getAllProducs, getProduct } from '../../utils/trackings';

export function trackAddToCollection(favoriteEntities: IFavoriteEntity[]) {
  const products = getAllProducs({ favoriteEntities });

  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'add_to_collection',
    label: '',
    products,
  });
}

export function trackFolderNameClick(offerId: number, folderId: number, favoriteEntities: IFavoriteEntity[]) {
  const { position } = getProduct(offerId, favoriteEntities);

  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'click_collection_name',
    label: folderId,
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position,
      },
    ],
  });
}

export const trackNotificationChangeFolderClick = (favoriteEntities: IFavoriteEntity[]) => {
  const products = getAllProducs({ favoriteEntities });

  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'Click',
    label: 'change_collection',
    products,
  });
};

export const trackNotificationSaveToFolderClick = (favoriteEntities: IFavoriteEntity[]) => {
  const products = getAllProducs({ favoriteEntities });

  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'Click',
    label: 'add_to_collection',
    products,
  });
};
